<template>
  <BaseModal
    @close="close"
    class="confirm-redirect"
  >
    <div class="confirm-redirect-container">
      <div class="confirm-redirect-body">
        <div class="confirm-redirect-body-center"><slot></slot></div>
      </div>
      <div class="confirm-redirect-footer">
        <BaseButton3 class="confirm-redirect-footer-button" :type="4" @click="close">{{lang.close}}</BaseButton3>
        <BaseButton3 class="confirm-redirect-footer-button" @click="commit">{{lang.commit}}</BaseButton3>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import {
  BaseButton2,
  BaseButton3
} from '../button'
import BaseModal from './BaseModal.vue'

export default {
  components: {
    BaseButton2,
    BaseButton3,
    BaseModal
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          close: '取消',
          commit: '确定'
        }
      }
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.confirm-redirect {
  & .confirm-redirect-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);
    border-radius: var(--borderRadius1);

    @media (--mediaPc) {
      height: 280px;
      width: 400px;
    }
    @media (--mediaMobile) {
      height: calc(400px / var(--scale));
      width: calc(600px / var(--scale));
    }

    & .confirm-redirect-body {
      position: relative;
      text-align: center;
      font-size: var(--textSize3);
      height: 70%;
      color: var(--colorGray0);

      & .confirm-redirect-body-center {
        margin: 0 72px;
        display: inline-block;
      }
      &::before {
        content: '';
        width: 0;
        height: 100%;
        display: inline-block;
        position: relative;
        vertical-align: middle;
      }
    }
    & .confirm-redirect-footer {
      text-align: center;
      bottom: calc(36px / var(--scale));
      & .confirm-redirect-footer-button {
        @media (--mediaPc) {
          width: 100px;
          margin: 0 20px;
        }
        @media (--mediaMobile) {
          width: calc(240px / var(--scale));
          margin: 0 calc(32px / var(--scale) / 2);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/ConfirmModal.vue